function SupportTicketStatus({ data }) {
    if (data?.demo || (data && data?.status === 'open')) return null;

    return (
        <div className="text-xs sm:text-sm text-white bg-error px-2 py-[2px] rounded-5">
            <span className="capitalize">{data?.status}</span>
        </div>
    );
}

export default SupportTicketStatus;
